import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PostByAgg from '../../utils/axios';
import ModalAlert from '../../components/ModalAlert';
import LottieLoading from '../../components/child/LottieLoading';

const AdminListForm = ({ open, onClose, action, selectedRow,refreshData }) => {
    const [formData, setFormData] = useState({
        username: '',
        full_name: '',
        email:'',
        description:''
    });
    const [modal, setModal] = useState(<div></div>);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (selectedRow && selectedRow.username) {
            // If selectedRow exists (for Edit or View)
            setFormData({
                username: selectedRow.username || '',
                full_name: selectedRow.full_name || '',
                email: selectedRow.email || '',
                description: selectedRow.description || ''
            });
        } else {
            // If no selectedRow (for Create)
            setFormData({
                username: '',
                full_name: '',
                email: '',
                description: ''
            });
        }
    }, [selectedRow]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        console.log("Form submitted with data:", formData);
            const url = 'user/um/v1/user-admin-registration'
            PostByAgg({
                url,
                body:{
                    "user_name": formData.username,
                    "full_name": formData.full_name,
                    "email": formData.email,
                    // "description": formData.description,
                    "created_by": "Super Admin",
                },
                onResponse: onResponseCreateAdmin,
                onError: onResponseErrorCreateAdmin
            })           
       
        function onResponseCreateAdmin(response) {
            setIsLoading(false);
            console.log("Response from createAdmin:", response.data)
            if(response.data.code === "2002000"){
                setModal(
                    <ModalAlert
                        show={true}
                        type={"success"}
                        text={response.data.message.id}
                        action = {() => {
                            setModal(<div></div>);
                            refreshData();
                            onClose();
                        }}
                    />
                    
                );
            }else{
                setModal(
                    <ModalAlert
                        show={true}
                        type={"failed"}
                        text={response.data.message.id}
                        action = {() => {
                            onClose();
                        }}
                        />
                    );

                }
            }

        function onResponseErrorCreateAdmin(error) {
            setIsLoading(false);
            setModal(
                <ModalAlert
                    show={true}
                    type={"failed"}
                    text={error.response.data.message.id}
                    action = {() => {
                        onClose();
                    }}
                    />
            )
        } 
    };
    


    return (
        <Modal
            show={open} // Control visibility using 'open' prop
            onHide={onClose} // Close the modal using onClose prop
            centered
            backdrop="static"
            size="lg"
            scrollable
        >
            <Modal.Header closeButton>
                <Modal.Title>{action === 'view' 
                ? 'View Admin' 
                : 'Create Admin'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form action='#' onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="col-form-label" htmlFor="user_name">
                                Username:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="username"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                                disabled={action === 'view'} // Disable if viewing
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="col-form-label" htmlFor="full_name">
                                Full Name:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="full_name"
                                name="full_name"
                                value={formData.full_name}
                                onChange={handleChange}
                                disabled={action === 'view'} // Disable if viewing
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="col-form-label" htmlFor="email">
                                Email:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                disabled={action === 'view'} // Disable if viewing
                            />
                        </div>
                        {/* <div className="col-md-6 mb-3">
                            <label className="col-form-label" htmlFor="description">
                                Description:
                            </label>
                            <textarea
                                type="text"
                                cols={"30"} 
                                rows={"5"}
                                className="form-control"
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                disabled={action === 'view'} // Disable if viewing
                            />
                        </div> */}
                    <Modal.Footer>
                    {isLoading ? (
                        <div className="d-flex justify-content-center">
                            <LottieLoading text="Processing..." />
                        </div>
                    ) : (
                        <Modal.Footer>
                            <Button variant="secondary" onClick={onClose}>Cancel</Button>
                            <Button variant="primary" type="submit">Submit</Button>
                        </Modal.Footer>
                    )}
                    </Modal.Footer>
                    </div>
            {modal}
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default AdminListForm;
